import { Drawer, Modal } from "antd"
import React from "react"

import { useAppSelector } from "../../../hooks/use-app-selector.ts"

interface PortalResponsiveModalProps {
  open: boolean
  onClose: () => void
  title: React.ReactNode
  children: React.ReactNode
  footer?: React.ReactNode
  width?: number
  maskClosable?: boolean
  closable?: boolean
}

/** Desktop keeps the centered `Modal` every other portal dialog already
 * uses; on a phone the same content becomes a full-screen `Drawer` (per the
 * redesign brief: event details/creation must be a full-screen panel on
 * mobile, never a small centered dialog squeezed onto the viewport). One
 * component so every calendar dialog gets this for free rather than each
 * re-implementing the isMobile branch. */
export function PortalResponsiveModal({
  open,
  onClose,
  title,
  children,
  footer,
  width = 520,
  maskClosable = true,
  closable = true
}: PortalResponsiveModalProps) {
  const isMobile = useAppSelector((state) => state.nav.isMobile)

  if (isMobile) {
    return (
      <Drawer
        open={open}
        onClose={onClose}
        title={title}
        placement="bottom"
        height="100%"
        maskClosable={maskClosable}
        closable={closable}
        footer={footer}
        styles={{ body: { paddingBottom: 24 } }}
      >
        {children}
      </Drawer>
    )
  }

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={title}
      footer={footer ?? null}
      width={width}
      maskClosable={maskClosable}
      closable={closable}
    >
      {children}
    </Modal>
  )
}
